var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.875 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.22 2H11.78C10.6754 2 9.78 2.89543 9.78 4V4.18C9.78006 4.89474 9.39857 5.55507 8.78 5.912L8.35 6.16C7.73084 6.51525 6.96916 6.51525 6.35 6.16L6.2 6.08C5.24277 5.52915 4.01925 5.85703 3.466 6.813L3.246 7.193C2.69275 8.14903 3.01927 9.37291 3.975 9.927L4.13 10.017C4.74977 10.3739 5.13169 11.035 5.131 11.75V12.25C5.13157 12.9653 4.74967 13.6269 4.13 13.984L3.975 14.073C3.01927 14.6271 2.69275 15.851 3.246 16.807L3.466 17.187C4.01925 18.143 5.24277 18.4709 6.2 17.92L6.35 17.84C6.96916 17.4848 7.73084 17.4848 8.35 17.84L8.78 18.088C9.39857 18.4449 9.78006 19.1053 9.78 19.82V20C9.78 21.1046 10.6754 22 11.78 22H12.22C13.3246 22 14.22 21.1046 14.22 20V19.82C14.2199 19.1053 14.6014 18.4449 15.22 18.088L15.65 17.84C16.2692 17.4848 17.0308 17.4848 17.65 17.84L17.8 17.92C18.7572 18.4709 19.9808 18.143 20.534 17.187L20.754 16.807C21.3072 15.851 20.9807 14.6271 20.025 14.073L19.87 13.984C19.2503 13.6269 18.8684 12.9653 18.869 12.25V11.75C18.8683 11.035 19.2502 10.3739 19.87 10.017L20.025 9.927C20.9807 9.37291 21.3072 8.14903 20.754 7.193L20.534 6.813C19.9808 5.85703 18.7572 5.52915 17.8 6.08L17.65 6.16C17.0308 6.51525 16.2692 6.51525 15.65 6.16L15.22 5.912C14.6014 5.55507 14.2199 4.89474 14.22 4.18V4C14.22 2.89543 13.3246 2 12.22 2Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsOutlined);
export default __webpack_public_path__ + "static/media/settings_outlined.78f9746c8dbbc3a9817050d2f42a0528.svg";
export { ForwardRef as ReactComponent };